import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import minzdrav from "../../../images/ministrys/Emblem_of_Ministry_of_Health_of_Russia.svg.png";
import minzdravsv from "../../../images/ministrys/Coat_of_Arms_of_Sverdlovsk_oblast.svg.png";
import roszdravnadzor from "../../../images/ministrys/Emblem_of_Roszdravnadzor.svg.png";
import obrnadzor from "../../../images/ministrys/Emblem_of_Rosobrnadzor.png";
import rospotrebnadzor from "../../../images/ministrys/Emblem_of_the_Federal_Service_for_the_Oversight_of_Consumer_Protection_and_Welfare.svg.png";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function Controls() {
  useSEO(seoConfig.controls);

  return (
    <section className="controls">
      <Breadcrumbs />

      <h1 className="controls__title">Органы управления</h1>
      <div className="controls__table">
        <div className="controls__blank">
          <h4 className="directions__more-title controls__more-title">
            <li className="licenses__content">
              Министерство здравоохранения Российской Федерации
            </li>
          </h4>

          <img
            src={minzdrav}
            alt="Министерство здравоохранения Российской Федерации"
            className="controls__image"
          />

          <div className="licenses__blank-link">
            <a
              href="https://minzdrav.gov.ru/"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>
        </div>

        <div className="controls__blank">
          <h4 className="directions__more-title controls__more-title">
            <li className="licenses__content">
              Министерство здравоохранения Свердловской области
            </li>
          </h4>

          <img
            src={minzdravsv}
            alt="Министерство здравоохранения Свердловской области"
            className="controls__image"
          />

          <div className="licenses__blank-link">
            <a
              href="https://minzdrav.midural.ru/"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>
        </div>

        <div className="controls__blank">
          <h4 className="directions__more-title controls__more-title">
            <li className="licenses__content">
              Федеральная служба по надзору в сфере здравоохранения
            </li>
          </h4>

          <img
            src={roszdravnadzor}
            alt="Федеральная служба по надзору в сфере здравоохранения"
            className="controls__image"
          />

          <div className="licenses__blank-link">
            <a
              href="https://roszdravnadzor.gov.ru/"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>
        </div>

        <div className="controls__blank">
          <h4 className="directions__more-title controls__more-title">
            <li className="licenses__content">
              Федеральная служба по надзору в сфере образования и науки
            </li>
          </h4>

          <img
            src={obrnadzor}
            alt="Федеральная служба по надзору в сфере образования и науки"
            className="controls__image"
          />

          <div className="licenses__blank-link">
            <a
              href="https://obrnadzor.gov.ru/"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>
        </div>

        <div className="controls__blank">
          <h4 className="directions__more-title controls__more-title">
            <li className="licenses__content">
              Федеральная служба по надзору в сфере защиты прав потребителей
            </li>
          </h4>

          <img
            src={rospotrebnadzor}
            alt="Федеральная служба по надзору в сфере защиты прав потребителей"
            className="controls__image"
          />

          <div className="licenses__blank-link">
            <a
              href="http://rospotrebnadzor.ru/"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>
        </div>
      </div>

      <div>
        <h2 className="antiCorruption__title">
          КОНТАКТЫ КОНТРОЛИРУЮЩИХ ОРГАНОВ
        </h2>
        <h3 className="about-nii__title antiCorruption__title">
          МИНИСТЕРСТВО ЗДРАВООХРАНЕНИЯ РОССИЙСКОЙ ФЕДЕРАЦИИ
        </h3>

        <p className="dissertation__text">
          <b>Михаил Альбертович Мурашко</b> Министр здравоохранения Российской
          Федерации
        </p>
        <p className="dissertation__text">
          127994, ГСП-4, г. Москва, Рахмановский пер, д. 3<br></br>
          <a
            href="mailto:info@minzdrav.gov.ru"
            className="dissertation__text additional__tel"
          >
            info@minzdrav.gov.ru{" "}
          </a>
          (кроме федеральных органов исполнительной власти и органов
          исполнительной власти субъектов Российской Федерации)
        </p>
        <p className="dissertation__text">
          Телефон справочной службы:{" "}
          <a
            href="tel:+74956272944"
            className="dissertation__text additional__tel"
          >
            +7 (495) 627-29-44
          </a>
        </p>
        <p className="dissertation__text">
          Многоканальный телефон:{" "}
          <a
            href="tel:+74956272400"
            className="dissertation__text additional__tel"
          >
            +7 (495) 627-24-00
          </a>
        </p>

        <h3 className="about-nii__title antiCorruption__title">
          ФЕДЕРАЛЬНАЯ СЛУЖБА ПО НАДЗОРУ В СФЕРЕ ЗДРАВООХРАНЕНИЯ СПРАВОЧНАЯ
          РОСЗДРАВНАДЗОРА
        </h3>

        <p className="dissertation__text">
          <b>Самойлова Алла Владимировна</b> Руководитель Федеральной службы по
          надзору в сфере здравоохранения
        </p>
        <p className="dissertation__text">
          109074, Москва, Славянская площадь, 4/1<br></br>
          <a
            href="mailto:info@roszdravnadzor.ru"
            className="dissertation__text additional__tel"
          >
            info@roszdravnadzor.ru
          </a>
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+74995780220"
            className="dissertation__text additional__tel"
          >
            +7 (499) 578-02-20
          </a>
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+74956248090"
            className="dissertation__text additional__tel"
          >
            +7 (495) 624-80-90
          </a>{" "}
          пресс-служба
        </p>

        <h3 className="about-nii__title antiCorruption__title">
          РОСЗДРАВНАДЗОР ПО СВЕРДЛОВСКОЙ ОБЛАСТИ
        </h3>

        <p className="dissertation__text">
          <b>Зильбер Наталья Александровна</b> Руководитель Территориального
          органа Росздравнадзора по Свердловской области
        </p>
        <p className="dissertation__text">
          620014, г. Екатеринбург, ул. Попова, д. 30<br></br>
          <a
            href="mailto:info@reg66roszdravnadzor.ru"
            className="dissertation__text additional__tel"
          >
            info@reg66roszdravnadzor.ru
          </a>
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+73433716362"
            className="dissertation__text additional__tel"
          >
            +7 (343) 371-63-62
          </a>
        </p>

        <h3 className="about-nii__title antiCorruption__title">
          МИНИСТЕРСТВО ЗДРАВООХРАНЕНИЯ СВЕРДЛОВСКОЙ ОБЛАСТИ
        </h3>

        <p className="dissertation__text">
          <b>Савинова Татьяна Леонидовна</b> Заместитель Губернатора
          Свердловской области - Министр здравоохранения Свердловской области
        </p>
        <p className="dissertation__text">
          620014, г. Екатеринбург, ул. Вайнера, 34б<br></br>
          <a
            href="mailto:minzdrav@egov66.ru"
            className="dissertation__text additional__tel"
          >
            minzdrav@egov66.ru
          </a>
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+73433120003"
            className="dissertation__text additional__tel"
          >
            +7 (343) 312-00-03
          </a>{" "}
          приемная МЗ СО
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+78001000153"
            className="dissertation__text additional__tel"
          >
            +7 (800) 1000-153
          </a>{" "}
          "Горячая линия" Министерства здравоохранения Свердловской области
        </p>
        <p className="dissertation__text">
          <a href="tel:122" className="dissertation__text additional__tel">
            122
          </a>{" "}
          Единая телефонная линия по вопросам распространения новой
          коронавирусной инфекции
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+78002340000"
            className="dissertation__text additional__tel"
          >
            +7 (800) 234-0000
          </a>{" "}
          Межведомственный Контакт-центр "Здоровье жителей Среднего Урала"
        </p>

        <h3 className="about-nii__title antiCorruption__title">
          ТЕРРИТОРИАЛЬНЫЙ ФОНД ОБЯЗАТЕЛЬНОГО МЕДИЦИНСКОГО СТРАХОВАНИЯ
          СВЕРДЛОВСКОЙ ОБЛАСТИ
        </h3>

        <p className="dissertation__text">
          <b>Шелякин Валерий Александрович</b> Директор ТФОМС Свердловской
          области
        </p>
        <p className="dissertation__text">
          620102, г. Екатеринбург, ул. Московская, 54<br></br>
          <a
            href="mailto:public@oms66.ru"
            className="dissertation__text additional__tel"
          >
            public@oms66.ru
          </a>
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+73432335000"
            className="dissertation__text additional__tel"
          >
            +7 (343) 233-50-00
          </a>{" "}
          Приемная ТФОМС предварительная запись обязательна по телефону
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+78002340000"
            className="dissertation__text additional__tel"
          >
            +7 (800) 234-00-00
          </a>{" "}
          Межведомственный контакт-центр "Здоровье жителей Среднего Урала"
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+73433629046"
            className="dissertation__text additional__tel"
          >
            +7 (343) 362-90-46
          </a>{" "}
          Телефон для обращений по вопросам получения полисов ОМС
        </p>

        <h3 className="about-nii__title antiCorruption__title">
          УПРАВЛЕНИЕ ФЕДЕРАЛЬНОЙ СЛУЖБЫ ПО НАДЗОРУ В СФЕРЕ ЗАЩИТЫ ПРАВ
          ПОТРЕБИТЕЛЕЙ И БЛАГОПОЛУЧИЯ ЧЕЛОВЕКА ПО СВЕРДЛОВСКОЙ ОБЛАСТИ
        </h3>

        <p className="dissertation__text">
          <b>Козловских Дмитрий Николаевич</b> Руководитель Управления
          Федеральной службы по надзору в сфере защиты прав потребителей и
          благополучия человека по Свердловской области - главный
          государственный санитарный врач по Свердловской области
        </p>
        <p className="dissertation__text">
          620078, г. Екатеринбург, пер. Отдельный, 3<br></br>
          <a
            href="mailto:mail@66 .rospotrebnadzor.ru"
            className="dissertation__text additional__tel"
          >
            mail@66 .rospotrebnadzor.ru
          </a>
        </p>
        <p className="dissertation__text">
          <a
            href="tel:+73433741379"
            className="dissertation__text additional__tel"
          >
            +7 (343) 374-13-79
          </a>
        </p>
      </div>
    </section>
  );
}
